export const powerRoles = [
  'support employee',
  'employee',
  'agent',
  'agency admin',
  'agency assistant',
  'agency principal',
  'dealer representative',
  'dealership location admin',
  'affiliate admin'
];

export const dealerRoles = [
  'dealer representative'
];